import { Component, Input, OnInit } from '@angular/core';
import { ConsumptionInterface } from '../../../../lines/models/consumption.interface';
import { environment } from '../../../../../../environments/environment';
import { select, Store } from '@ngrx/store';
import { ConstsHelper } from '../../../../../helpers/consts.helper';
import { ConsumptionInterfaceState } from '../../../../lines/store/state/consumption.state';
import { UpdateSelectedProcedure } from '../../../store/actions/selected-procedure.actions';
import { SaveMission } from '../../../store/actions/mission.actions';
import { LineInterface } from '../../../../lines/models/line.interface';
import { PriceDetailsInterface } from '../../../models/price-details.interface';

@Component({
  selector: 'app-recharge-voice',
  templateUrl: './recharge-voice.component.html',
  styleUrls: ['./recharge-voice.component.css'],
  standalone: false
})
export class RechargeVoiceComponent implements OnInit {
  @Input()
  line: LineInterface;

  @Input()
  procedureCode: string;

  @Input()
  priceDetails?: PriceDetailsInterface;

  consumption: ConsumptionInterface = null;
  environment = environment;
  formSubmitted: boolean;

  constructor(private store: Store<any>) {}

  ngOnInit() {
    this.formSubmitted = false;
    this.store.pipe(select(ConstsHelper.REDUCER_CONSUMPTION)).subscribe((response: ConsumptionInterfaceState) => {
      if (false === (response.consumption instanceof Array) && null !== response.consumption) {
        this.consumption = response.consumption;
      }
    });
  }

  cancel() {
    this.store.dispatch(new UpdateSelectedProcedure(''));
  }

  send() {
    if (this.formSubmitted === false) {
      this.formSubmitted = true;
      this.store.dispatch(new SaveMission({step: 1, phoneNumber: this.line.phoneNumber}, this.procedureCode));
    }
  }
}
